class YGScriptLoader extends HTMLElement {
  loadScript(url, fn) {
    if (url) {
      let loadScript = document.createElement('script')
      loadScript.src = url
      document.body.appendChild(loadScript)

      loadScript.onload = () => {
        fn()
      }

      loadScript.onerror = (err) => {
        console.error(err)
      }
    }
  }
}

class YGDetails extends HTMLElement {
  constructor() {
      super()
      this.init()
  }
  init() {
    // 这里放置自定义逻辑 
    let YGDetails = this.querySelectorAll('.yg-details')
    YGDetails.forEach((item) => {
      let title = item.querySelector('.yg-details-title');
      let content = item.querySelector('.yg-details-content');
      let btn = item.querySelector('.yg-right svg');
      this.clickTab(title, content , btn) ;
      
    })
  }

  clickTab(title, content, btn) {
      // title: title元素
      // content: content元素
      let height = content.offsetHeight + 12;
      content.style.height = '0';

      title.addEventListener("click",function(){
        if(content.classList.contains('active')){
            content.style.height = '0';
            content.style.paddingTop = '0';
            btn.style.transform = 'none';
            content.classList.remove('active')
        }else{
            content.style.height = `${height}px`;
            content.style.paddingTop = '12px';
            btn.style.transform = 'rotate(180deg)';
            content.classList.add('active');
        }
    })
  }
}
if (!window.customElements.get('yg-details')) {
  window.customElements.define('yg-details',YGDetails)
}